import React, { FC } from 'react';
import { Typography, Card } from '@mui/material';

import { ShsRadioButtonGroup, ShsSelectInput, ShsTextInput } from '../../common';
import {
    CONSULTATION_TYPE,
    HIGH_SCHOOL_GRADES_LABELS,
    JUNIOR_SCHOOL_GRADES_LABELS,
    PRE_SCHOOL_YEARS_LABELS,
    SUBJECT_TYPE
} from '../../../constants';
import { SubjectControlsGrid } from './SubjectControlsGrid';
import { Theme } from 'src/Theme';
import { CONSULTATION_DURATION, CONSULTATION_TYPE_LIST, SUBJECTS_LIST } from '../common/const';
import { useWatch } from 'react-hook-form';

const separatorStyles = { mb: 1, mt: 3 };

export const SubjectsEditCard: FC = () => {
    const { subject_type } = useWatch();
    const isPsychologySubjectType = subject_type === SUBJECT_TYPE.PSYCHOLOGY;
    const isForeignSubjectType = subject_type === SUBJECT_TYPE.FOREIGN;

    return (
        <Card sx={{ width: '100%', mb: 2, p: 4 }}>
            <ShsTextInput required source={'name'} label="Назва предмету" />
            <ShsRadioButtonGroup
                row={false}
                sx={{ color: Theme.palette.primary.midnightBlue }}
                source={'subject_type'}
                choices={SUBJECTS_LIST}
                label="Тип предмету"
                required
                isEdit
            />
            {isPsychologySubjectType ? (
                <>
                    <ShsRadioButtonGroup
                        row={false}
                        sx={{ color: Theme.palette.primary.midnightBlue }}
                        source={'consultationType'}
                        defaultValue={CONSULTATION_TYPE.WITH_PUPILS}
                        choices={CONSULTATION_TYPE_LIST}
                        label="Психологія"
                        required
                    />

                    <ShsSelectInput
                        source={'durationMinutes'}
                        label="Тривалість консультації"
                        choices={CONSULTATION_DURATION}
                        defaultValue={40}
                        required
                        isTruncatedOptions
                        style={{ width: '70px' }}
                    />
                </>
            ) : (
                <>
                    {!isForeignSubjectType && (
                        <Typography fontSize="16px" fontWeight="500" sx={{ ...separatorStyles }}>
                            Дошкільна освіта
                        </Typography>
                    )}
                    {!isForeignSubjectType && <SubjectControlsGrid schoolPlanning={PRE_SCHOOL_YEARS_LABELS} />}
                    <Typography fontSize="16px" fontWeight="500" sx={{ ...separatorStyles }}>
                        1-4 класи
                    </Typography>
                    <SubjectControlsGrid schoolPlanning={JUNIOR_SCHOOL_GRADES_LABELS} />
                    <Typography fontSize="16px" fontWeight="500" sx={{ ...separatorStyles }}>
                        5-11 класи
                    </Typography>
                    <SubjectControlsGrid schoolPlanning={HIGH_SCHOOL_GRADES_LABELS} />
                </>
            )}
        </Card>
    );
};
